module.exports = __webpack_public_path__ + "56ccaab8501462972d3b224f4d66e9e2.svg";